import { render, staticRenderFns } from "./examCenter_activationCode.vue?vue&type=template&id=637fd088&scoped=true"
import script from "./examCenter_activationCode.vue?vue&type=script&lang=js"
export * from "./examCenter_activationCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637fd088",
  null
  
)

export default component.exports